import {
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
} from '@mui/material';

const DataProfilingPage = ({ columns, disableForm, handleSetColumn, handleSetColumnParams, validationList }) => {
  return (
    <div>
      {columns?.length > 0 && (
        <TableContainer sx={{ maxHeight: 500 }}>
          <Table stickyHeader size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell>Columns</TableCell>
                <TableCell>Validation</TableCell>
                <TableCell>Params</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {columns.map((row, i) => {
                return (
                  <TableRow hover key={i}>
                    <TableCell>{row.column}</TableCell>
                    <TableCell>
                      <TextField
                        id="standard-select-currency"
                        select
                        label="Validation"
                        name="validation_name"
                        disabled={disableForm}
                        value={row.validation_name}
                        onChange={(event) => {
                          handleSetColumn(event, row.column);
                        }}
                        style={{ width: '100%' }}
                        size="small"
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        {validationList.map((el, i) => (
                          <MenuItem key={i} value={el.validation_name}>
                            <Tooltip title={el.description}>
                              <span> {el.validation_name} </span>
                            </Tooltip>
                          </MenuItem>
                        ))}
                      </TextField>
                    </TableCell>
                    <TableCell style={{ display: 'flex' }}>
                      {validationList
                        .find((item) => item.validation_name === row.validation_name)
                        ?.params_list?.map((item) => (
                          <TextField
                            name={item}
                            label={item}
                            size="small"
                            value={row[item]}
                            style={{ width: '200px' }}
                            disabled={disableForm}
                            onChange={(e) => {
                              handleSetColumnParams(e, row.column, item);
                            }}
                          />
                        ))}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};
export default DataProfilingPage;
